import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/styles.scss';export default {
  "groupEditionForm": "_groupEditionForm_1un00_1",
  "group": "_group_1un00_1",
  "title": "_title_1un00_9",
  "input": "_input_1un00_20",
  "textArea": "_textArea_1un00_35"
};